module.exports = __webpack_public_path__ + "static/media/icon_device_off.ef4ef70f.svg";